import React from 'react';
import { cn } from 'lib/utils';
import { Button } from './button';

export interface EmptyStateAction {
  label: string;
  onClick: () => void;
  icon?: React.ReactNode;
}

export interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  /** The list's first step (create, invite, upload): the screen's lime primary. */
  action?: EmptyStateAction;
  /** A way back from no results or a failed load ("Filtrlarni tozalash", "Qayta urinish"): secondary. */
  secondaryAction?: EmptyStateAction;
  className?: string;
}

/** A grey 40px circle, a 15px title, one muted line, then the actions. */
const EmptyState: React.FC<EmptyStateProps> = ({ icon, title, description, action, secondaryAction, className }) => (
  <div className={cn('flex flex-col items-center justify-center px-6 py-12 text-center', className)}>
    {icon && (
      <span
        aria-hidden
        className="mb-2.5 flex h-10 w-10 items-center justify-center rounded-full bg-muted text-muted-foreground [&_svg]:h-[18px] [&_svg]:w-[18px]"
      >
        {icon}
      </span>
    )}
    <h3 className="text-[15px] font-semibold leading-[22px] text-foreground">{title}</h3>
    {description && <p className="mt-1 max-w-[360px] text-[13.5px] leading-5 text-muted-foreground">{description}</p>}
    {(action || secondaryAction) && (
      <div className="mt-3.5 flex flex-wrap items-center justify-center gap-2">
        {secondaryAction && (
          <Button variant="outline" size="xs" className="gap-1.5" onClick={secondaryAction.onClick}>
            {secondaryAction.icon}
            {secondaryAction.label}
          </Button>
        )}
        {action && (
          <Button className="gap-1.5" onClick={action.onClick}>
            {action.icon}
            {action.label}
          </Button>
        )}
      </div>
    )}
  </div>
);

export default EmptyState;
